export type KitchenTicketStatus = 'pending' | 'preparing' | 'ready' | 'delivered' | 'cancelled';

export type KitchenTicketItemStatus = 'pending' | 'preparing' | 'ready' | 'delivered';

export interface KitchenTicketItemComponent {
  id: string;
  productId?: string;
  productName: string;
  quantity: number;
}

export interface KitchenTicketItem {
  id: string;
  productId?: string;
  productName: string;
  quantity: number;
  /** Units cancelled after this line was dispatched to the kitchen. */
  cancelledQuantity: number;
  categoryName?: string;
  status: KitchenTicketItemStatus;
  startedAt?: Date | null;
  readyAt?: Date | null;
  deliveredAt?: Date | null;
  notes?: string;
  /** Promo bundle contents, when this line is a promo parent. */
  components?: KitchenTicketItemComponent[];
}

/**
 * One dispatch of kitchen items for a tab (mirrors what used to be printed as
 * a single comanda). A tab can have multiple active tickets at once - e.g. a
 * dessert ordered after the main course already shipped becomes its own
 * ticket instead of reopening the original one.
 */
export interface KitchenTicket {
  id: string;
  tabId: string;
  organizationId: string;
  status: KitchenTicketStatus;
  customerName: string;
  serverName?: string;
  tableId?: string | null;
  items: KitchenTicketItem[];
  createdAt: Date;
  startedAt?: Date | null;
  readyAt?: Date | null;
  deliveredAt?: Date | null;
  cancelledAt?: Date | null;
  updatedAt: Date;
}

export const isItemFullyCancelled = (item: KitchenTicketItem): boolean =>
  item.cancelledQuantity >= item.quantity;

export const isItemActive = (item: KitchenTicketItem): boolean => !isItemFullyCancelled(item);

export const isTicketFullyCancelled = (ticket: KitchenTicket): boolean =>
  ticket.items.length > 0 && ticket.items.every(isItemFullyCancelled);
